export default {
  APPSupport: {
    getPageTypeOptions: 'api/appSupport/getPageTypeOptions',
    appConfig: {
      getList: 'api/appConfig/getList',
      add: 'api/appConfig/add',
      update: 'api/appConfig/update',
      del: 'api/appConfig/del',
      changeStatus: 'api/appConfig/changeStatus',
    },
    versionConfig: {
      getAPPPlatforms: 'api/versionConfig/getAPPPlatforms',
      getList: 'api/versionConfig/getList',
      del: 'api/versionConfig/del',
      add: 'api/versionConfig/add',
      update: 'api/versionConfig/update',
      changeStatus: 'api/versionConfig/changeStatus',
      getQRCodeUrl: 'api/versionConfig/getQRCodeUrl'
    },
    gtPush: {
      getConfig: 'api/gtPush/getConfig',
      saveOrUpdate: 'api/gtPush/saveOrUpdate',
      getDeviceList: 'api/gtPush/getDeviceList',
      pushMsg: 'api/gtPush/pushMsg',
      getPushLog: 'api/gtPush/getPushLog'
    },
    feedbackApi: {
      getList: 'api/feedback/getList',
      fixed: 'api/feedback/fixed',
      del: 'api/feedback/del',
    }
  }
}
